(function () {
  'use strict';
  const typeNames = {desktop:'desktop processors',laptop:'laptop processors',server:'server processors'};
  function classify(data) {
    // An imported source category takes precedence over words in a system's specifications.
    if (data.catalogCategory && data.catalogCategory !== 'processors') return null;
    const title=String(data.title||'').toLowerCase();
    // Board bundles and CPU accessories belong in their own categories.
    if(/motherboard|logic board|system board|system mb|mainboard|heatsink|heat sink|cooler|cooling|thermal|socket adapter|retention|mounting bracket|\b(?:fan|laptop|desktop|server)\s+(?:computer|pc|system)\b/.test(title))return null;
    const override=String(data.processorType||'').trim().toLowerCase();
    if(!Object.hasOwn(typeNames,override)&&! /\b(?:cpus?|processors?|pentium|celeron|xeon|ryzen|epyc|athlon|threadripper)\b|\bintel\s+core\b/.test(title))return null;
    let type=Object.hasOwn(typeNames,override)?override:'';
    // Only use explicit system-type wording; ambiguous CPUs remain in Browse all.
    const words=title+' '+String(data.description||'').toLowerCase();
    if(!type){
      const found=[['laptop',/\b(?:laptop|notebook|mobile)\b/],['server',/\bserver\b/],['desktop',/\bdesktop\b/]].filter(([,pattern])=>pattern.test(words));
      if(found.length===1)type=found[0][0];
    }
    const brand=/\bintel\b/.test(title)?'Intel':/\bamd\b/.test(title)?'AMD':String(data.vendor||'').trim()||'Unspecified brand';
    return {type,brand};
  }
  function normalize(value) {return String(value || '').toLowerCase().replace(/[^a-z0-9]/g,'');}
  function matchesModel(data, query) {
    const key = normalize(query);
    return !key || [data.title, data.model].some(value=>normalize(value).includes(key));
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {classify,matchesModel};
  if (typeof document === 'undefined') return;
  if (window.tekProcessorLoaded) return;
  window.tekProcessorLoaded = true;
  function init(root) {
    if (root.dataset.processorReady) return;
    const trigger = root.querySelector('[data-processor-trigger]');
    const panel = root.querySelector('[data-processor-picker]');
    if (!trigger || !panel) return;
    root.dataset.processorReady = 'true';
    const type = panel.querySelector('[data-processor-type]');
    const brand = panel.querySelector('[data-processor-brand]');
    const model = panel.querySelector('[data-processor-model]');
    const submit = panel.querySelector('[data-processor-submit]');
    const status = panel.querySelector('[data-processor-status]');
    const results = panel.querySelector('[data-processor-results]');
    const retry = panel.querySelector('[data-processor-retry]');
    const browse = panel.querySelector('[data-processor-browse]');
    let entries = [], loading = false, query = '';
    function resetBrands() {brand.replaceChildren(new Option('All brands',''));brand.disabled=true;}
    function fillBrands() {
      resetBrands();
      const counts = new Map();
      entries.filter(entry=>!type.value||entry.type===type.value).forEach(entry=>counts.set(entry.brand,(counts.get(entry.brand)||0)+1));
      [...counts].sort(([a],[b])=>a.localeCompare(b)).forEach(([name,count])=>brand.add(new Option(name+' ('+count+')',name)));
      brand.disabled=!counts.size;
      if(!counts.size)brand.options[0].textContent='No brands in stock';
    }
    function refresh() {
      results.replaceChildren();
      if(model.value.trim()!==query){status.textContent='Select Model Number Search to apply your search.';return;}
      const byType=entries.filter(entry=>!type.value||entry.type===type.value);
      if (!byType.length) {status.textContent='No '+(typeNames[type.value]||'processors')+' are currently in stock. Try another processor type.';return;}
      const selected=byType.filter(entry=>(!brand.value||entry.brand===brand.value)&&matchesModel(entry.template.dataset,query));
      if (!selected.length) {status.textContent='No available processors match '+(query?'“'+query+'”':'these filters')+'. Check the model number or change the processor type or brand.';return;}
      for (const entry of selected) results.append(document.importNode(entry.template.content,true));
      status.textContent=selected.length+' '+(brand.value?brand.value+' ':'')+(type.value?(typeNames[type.value].replace(/processors$/,'processor')+' '):'processor ')+(selected.length===1?'listing':'listings')+' in stock'+(query?' matching “'+query+'”':'')+'.';
    }
    type.addEventListener('change',()=>{fillBrands();refresh();});
    brand.addEventListener('change',refresh);
    browse.addEventListener('click',()=>{
      type.value='';query='';model.value='';model.setCustomValidity('');fillBrands();refresh();
    });
    model.addEventListener('input',()=>{
      model.setCustomValidity('');
      if(!model.value.trim()){query='';refresh();return;}
      // Clear old results immediately so they cannot be mistaken for the new query.
      if(model.value.trim()!==query){results.replaceChildren();status.textContent='Select Model Number Search to apply your search.';}
    });
    panel.querySelector('[data-processor-search]').addEventListener('submit',event=>{
      event.preventDefault();if(loading||submit.disabled)return;
      if(model.value.trim()&&!normalize(model.value)){model.setCustomValidity('Enter letters or numbers from the model or part number.');model.reportValidity();return;}
      query=model.value.trim();refresh();
    });
    async function load() {
      if(loading)return;
      loading=true;entries=[];query='';type.value='';model.value='';model.setCustomValidity('');type.disabled=true;model.disabled=true;submit.disabled=true;browse.disabled=true;
      resetBrands();results.replaceChildren();retry.hidden=true;
      panel.setAttribute('aria-busy','true');status.textContent='Loading available processors…';
      try {
        let url=new URL(panel.dataset.feedUrl,location.origin);url.searchParams.set('section_id','tek-memory-feed');
        const pages=new Set(),products=new Set(),loaded=[];
        while(url){
          if(url.origin!==location.origin||pages.has(url.href))throw new Error('Invalid inventory page');
          pages.add(url.href);
          const response=await fetch(url,{signal:AbortSignal.timeout(15000),cache:'no-store'});
          if(!response.ok)throw new Error('Inventory unavailable');
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          if(!doc.querySelector('[data-memory-feed]'))throw new Error('Inventory unavailable');
          for(const template of doc.querySelectorAll('template[data-memory-item]')){
            if(products.has(template.dataset.handle))continue;products.add(template.dataset.handle);
            const info=classify(template.dataset);if(info)loaded.push({...info,template});
          }
          const next=doc.querySelector('[data-memory-next]');url=next?new URL(next.getAttribute('href'),url):null;
          if(url)url.searchParams.set('section_id','tek-memory-feed');
        }
        entries=loaded;type.disabled=false;model.disabled=false;submit.disabled=false;browse.disabled=false;fillBrands();refresh();
        if(!entries.length)status.textContent='No processors are currently in stock. Try again later.';
      } catch {status.textContent='We could not load current processor inventory. Please try again.';retry.hidden=false;}
      finally {loading=false;panel.removeAttribute('aria-busy');}
    }
    trigger.setAttribute('aria-controls',panel.id);trigger.setAttribute('aria-expanded','false');
    function close(){panel.hidden=true;trigger.setAttribute('aria-expanded','false');trigger.focus();}
    root.addEventListener('tp:picker-open',event=>{if(event.detail!==panel){panel.hidden=true;trigger.setAttribute('aria-expanded','false');}});
    trigger.addEventListener('click',event=>{
      event.preventDefault();if(!panel.hidden){close();return;}
      root.dispatchEvent(new CustomEvent('tp:picker-open',{detail:panel}));
      panel.hidden=false;trigger.setAttribute('aria-expanded','true');panel.querySelector('[data-processor-heading]').focus({preventScroll:true});panel.scrollIntoView({block:'start',behavior:'instant'});load();
    });
    panel.querySelector('[data-processor-close]').addEventListener('click',close);
    panel.addEventListener('keydown',event=>{if(event.key==='Escape')close();});retry.addEventListener('click',load);
  }
  function scan(){document.querySelectorAll('[data-category-gallery]').forEach(init);}
  scan();document.addEventListener('shopify:section:load',scan);
})();
